export const FETCH_CARE_PLAN_TASKS = "app/CarePlanTask/FETCH_CARE_PLAN_TASKS";
export const FETCH_CARE_PLAN_TASKS_SUCCESS =
  "app/CarePlanTask/FETCH_CARE_PLAN_TASKS_SUCCESS";
export const FETCH_CARE_PLAN_TASKS_FAILURE =
  "app/CarePlanTask/FETCH_CARE_PLAN_TASKS_FAILURE";

export const ADD_CARE_PLAN_TASK = "app/CarePlanTask/ADD_CARE_PLAN_TASK";
export const ADD_CARE_PLAN_TASK_SUCCESS =
  "app/CarePlanTask/ADD_CARE_PLAN_TASK_SUCCESS";
export const ADD_CARE_PLAN_TASK_FAILURE =
  "app/CarePlanTask/ADD_CARE_PLAN_TASK_FAILURE";

export const EDIT_CARE_PLAN_TASK = "app/CarePlanTask/EDIT_CARE_PLAN_TASK";
export const EDIT_CARE_PLAN_TASK_SUCCESS =
  "app/CarePlanTask/EDIT_CARE_PLAN_TASK_SUCCESS";
export const EDIT_CARE_PLAN_TASK_FAILURE =
  "app/CarePlanTask/EDIT_CARE_PLAN_TASK_FAILURE";

export const DELETE_CARE_PLAN_TASK = "app/CarePlanTask/DELETE_CARE_PLAN_TASK";
export const DELETE_CARE_PLAN_TASK_SUCCESS =
  "app/CarePlanTask/DELETE_CARE_PLAN_TASK_SUCCESS";
export const DELETE_CARE_PLAN_TASK_FAILURE =
  "app/CarePlanTask/DELETE_CARE_PLAN_TASK_FAILURE";

export const FETCH_CARE_PLAN_TASK_TEMPLATES =
  "app/CarePlanTask/FETCH_CARE_PLAN_TASK_TEMPLATES";
export const FETCH_CARE_PLAN_TASK_TEMPLATES_SUCCESS =
  "app/CarePlanTask/FETCH_CARE_PLAN_TASK_TEMPLATES_SUCCESS";
export const FETCH_CARE_PLAN_TASK_TEMPLATES_FAILURE =
  "app/CarePlanTask/FETCH_CARE_PLAN_TASK_TEMPLATES_FAILURE";

export const MARK_CARE_PLAN_TASK_STATUS =
  "app/CarePlanTask/MARK_CARE_PLAN_TASK_STATUS";
export const MARK_CARE_PLAN_TASK_STATUS_SUCCESS =
  "app/CarePlanTask/MARK_CARE_PLAN_TASK_STATUS_SUCCESS";
export const MARK_CARE_PLAN_TASK_STATUS_FAILURE =
  "app/CarePlanTask/MARK_CARE_PLAN_TASK_STATUS_FAILURE";
